import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

function getIsLoyaltyLuxPlusRenewalBonusEnabled(state: App.State): boolean {
  return getIsLoyaltyEnabled(state) && state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.loyaltyLuxPlusRenewalReward]
}

export default getIsLoyaltyLuxPlusRenewalBonusEnabled
